import React, { useState, useEffect } from 'react'
import PieChart from './PieChart'
import { useExercise } from '.././ExerciseProvider'
import { useTranslation } from '../../../hooks/useTranslation'

const ExerciseForm = ({ data, slug }) => {
  const { updatePieOfLifeResponse, formattedExerciseName } = useExercise()
  const [localData, setLocalData] = useState(data || {})
  const [chartData, setChartData] = useState(data || {})
  const { t } = useTranslation(formattedExerciseName)

  // Synchronize local state with updated data prop
  useEffect(() => {
    setLocalData(data || {})
    setChartData(data || {})
  }, [data])

  const handleInputChange = (field, value) => {
    const numericValue = Math.max(0, Number(value))
    setLocalData((prev) => ({
      ...prev,
      [field]: numericValue,
    }))
  }

  const handleInputBlur = (field, value) => {
    updatePieOfLifeResponse(slug, field, value)
    setChartData((prev) => ({
      ...prev,
      [field]: value,
    }))
  }

  const formatFieldName = (field) => t(`data_labels.${field}`)

  return (
    <div className="flex items-center justify-center">
      <div className="mr-40 flex flex-col space-y-4">
        {[
          'career',
          'healthAndWellness',
          'financial',
          'personalDevelopment',
          'relationships',
          'leisure',
        ].map((field) => (
          <div key={field} className="flex w-full items-center justify-between">
            <label className="text-base" htmlFor={`${slug}-${field}`}>
              {formatFieldName(field)}
            </label>
            <input
              type="number"
              id={`${slug}-${field}`}
              name={field}
              className="ml-2 w-20"
              value={localData?.[field] || ''}
              onChange={(e) => handleInputChange(field, e.target.value)}
              onBlur={(e) => handleInputBlur(field, e.target.value)}
              autoComplete="off"
              min="0"
            />
          </div>
        ))}
      </div>
      <PieChart data={chartData} />
    </div>
  )
}

export default ExerciseForm
